var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRatingEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 19,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.322.423a.754.754 0 011.356 0l2.65 5.44 6.022.829a.749.749 0 01.419 1.283c-1.61 1.538-4.382 4.191-4.382 4.191l1.069 5.952a.751.751 0 01-1.097.793L10 16.06l-5.359 2.851a.751.751 0 01-1.097-.793l1.07-5.952L.232 7.975a.75.75 0 01.419-1.283l6.021-.829 2.65-5.44z",
    fill: "#949494",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "ca60dd8564099769c24585e192e9abc6.svg";
export { SvgRatingEmpty as ReactComponent };